
import AnimatedText from '../../../components/base/AnimatedText';

export default function RecruitSection() {
  return (
    <section id="recruit" className="py-20 bg-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://public.readdy.ai/ai/img_res/470f7b778d60dee0f9e1343c3b3581fc.jpg"
          alt="Background"
          className="w-full h-full object-cover object-top"
        />
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <AnimatedText
            text="スタッフ募集"
            className="text-4xl font-bold text-white mb-4"
          />
          <div className="w-24 h-1 bg-blue-500 mx-auto mb-6"></div>
          <AnimatedText
            text="一緒に最高のおもてなしを創り上げる仲間を募集しています"
            className="text-xl text-gray-300"
            delay={300}
          />
        </div>

        <div className="bg-gray-900/70 backdrop-blur-sm rounded-lg p-8 border border-blue-500/20 mb-8">
          <div className="text-center">
            <h4 className="text-xl font-bold text-white mb-4">応募・お問い合わせ</h4>
            <p className="text-gray-300 mb-6">
              まずはお気軽にLINEでご連絡ください。<br />
              面接日時等、詳細についてご相談させていただきます。
            </p>
            <div className="flex items-center justify-center mb-4">
              <a 
                href="https://lin.ee/lhF3oA2" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-8 rounded-full transition-colors duration-300 flex items-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-line-fill text-2xl mr-3"></i>
                LINEで応募する
              </a>
            </div>
            <p className="text-gray-400 text-sm">
              ※応募の際は「求人を見た」とお伝えください
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}
